export default __webpack_public_path__ + "static/media/success.570c2af0.svg";